<template>
  <div>
    <v-card class="ma-6 pa-6 pb-0" outlined>
      <DiligenceDateReportFilter @onFilterChanged="refresh" />
    </v-card>

    <v-card class="ma-6" outlined>
      <DiligenceDateReportTable ref="diligence-data-table" :filters="filters" />
    </v-card>
  </div>
</template>

<script>
import StudentBlankView from '@/components/basic/StudentBlankView.vue'
import DiligenceDateReportFilter from './components/DiligenceDateReportFilter.vue'
import DiligenceDateReportTable from './components/DiligenceDateReportTable.vue'

export default {
  components: {
    DiligenceDateReportTable,
    DiligenceDateReportFilter,
    StudentBlankView,
  },
  data() {
    return {
      action: {
        state: 'select',
      },
      filters: null,
    }
  },
  methods: {
    refresh(query) {
      this.action.state = 'filtered'
      this.filters = query
      console.log(query)
      this.$nextTick(() => {
        this.$refs['diligence-data-table'].searchStudentDiligences()
      })
    },
  },
}
</script>
